<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))" v-model="queryParam.orderNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('phoneNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('phoneNo'))"
                v-model="queryParam.mobileNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :scroll="{ x: 2300, y: 2000 }"
        :pagination="false"
        :loading="loading"
        bordered>
        <Dict slot="loanStatus" slot-scope="text" :dict-code="DICT_CODE.LOAN_STATUS" :value="text"/>
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS" :value="text"/>
        <Dict slot="approvalStatus2" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS2" :value="text"/>
        <Dict slot="settleStatus" slot-scope="text" :dict-code="DICT_CODE.INSTALLMENT_SETTLE_STATUS" :value="text"/>
        <Dict slot="overdueStatus" slot-scope="text" :dict-code="DICT_CODE.OVERDUE_STATUS" :value="text"/>
        <span slot="action" slot-scope="text, record">
          <a @click="handleOrderDetail(record)" v-if='record.approvalStatus == 4 && record.approvalStatus2 == 5 && record.loanStatus == 1'>
            Repayment Plan
          </a>
          <a @click="handleLoan(record.id)" v-if='record.approvalStatus == 4 && record.approvalStatus2 == 5 && record.loanStatus == 3'>
            Disburse Loan
          </a>

          <a @click="handleFailed(record.id)" v-if='record.approvalStatus == 4 && record.approvalStatus2 == 5 && record.loanStatus == 3'>
            Disbursement Failed
          </a>
          <a @click="handleOrderEdit(record)" v-if='record.approvalStatus2 != 5'>
            Edit Order
          </a>
          <a @click="handleAB(record.id)" v-if='record.approvalStatus == 4 && record.approvalStatus2 == 5 && record.loanStatus == 1 && record.settleStatus == 0'>
            Abandon Loan
          </a>
          <a @click="handleEdit(record)" v-if='record.approvalStatus == 4 && record.approvalStatus2 == 5 && record.loanStatus == 1 && record.settleStatus == 0'>
            Edit Repayment Plan
          </a>
          <a @click="downLoadData(record, '1')" type="button" icon="download" style="margin-left: 8px">
            Export JSON
          </a>
          <a @click="downLoadData(record, '0')" type="button" icon="download" style="margin-left: 8px">
            Original JSON
          </a>
        </span>

<!--        <a-table-->
<!--          slot="expandedRowRender"-->
<!--          slot-scope="text"-->
<!--          ref="table"-->
<!--          size="middle"-->
<!--          :columns="innerColumns"-->
<!--          :data-source="text.repayPlans"-->
<!--          :loading="loading"-->
<!--          :pagination="false"-->
<!--          bordered>-->
<!--        </a-table>-->
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
          <v-pagination
              v-if="total"
              :page-num="form.pageNum"
              :page-size="form.pageSize"
              :total="total"
              @change="handleTableChange" />
      </div>
    </div>
    <v-modal
        v-model="visible"
        :title="$t(I18N_KEY + 'orderDetail')">
        <div style="padding: 20px;">
            <order-detail v-if="visible" :orderId="orderId" :custInfoId="custInfoId"/>
        </div>
    </v-modal>
    <TestInstallOrderModal ref="modalForm" @ok="modalFormOk"></TestInstallOrderModal>
    <TestInstallOrderModalTVn ref="modalFormT" @ok="modalFormOkT"></TestInstallOrderModalTVn>
    <TestInstallOrderListModal ref="modalFormF" @ok="modalFormOk"></TestInstallOrderListModal>

  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getPlatformAllOrderList,
  clearOrderForTest,
  getInstallmentPlatformAllOrderList,
  installmentLoanOrder, installmentLoanOrderFailed, installmentLoanOrderLoaning, installmentLoanOrderAB
} from '@/webpublicapi/order'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import vModal from '../modules/Modal';
import OrderDetail from '../order/OrderDetail';
import moment from 'moment';
import TestInstallOrderModal from './modules/TestInstallOrderModal';
import TestInstallOrderModalTVn from './modules/TestInstallOrderModalTVn';
import TestInstallOrderListModal from './modules/TestInstallOrderListModal';

import exportFile from '@/webpublicapi/exportFile'



const I18N_KEY = 'order.';
export default {
  name: 'TestInstallOrderListVn',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail,
    TestInstallOrderModal,
    TestInstallOrderModalTVn,
    TestInstallOrderListModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      // Query parameters
      queryParam: {
        "orderNo":"",
        "mobileNo":"",
        "appssid":"",
        "aadhaarName":"",
        "createdTime":undefined,
        "loanStatus": '',
        "approvalStatus": '',
        "approvalStatus2": '',
        "settleStatus": '',
      },
      loading: false,
      // Table headers
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: 'App SSID',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t(I18N_KEY + 'applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        // {
        //   title: this.$t(I18N_KEY + 'deductionFee'),
        //   align: 'left',
        //   dataIndex: 'deductionFee'
        // },
        {
          title: this.$t(I18N_KEY + 'deadline'),
          align: 'left',
          dataIndex: 'duration'
        },
        {
          title: this.$t(I18N_KEY + 'loanStatus'),
          align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus2'),
          align: 'left',
          dataIndex: 'approvalStatus2',
          scopedSlots: { customRender: 'approvalStatus2' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        // {
        //   title: this.$t(I18N_KEY + 'overdueStatus'),
        //   align: 'left',
        //   dataIndex: 'overdueStatus',
        //   scopedSlots: { customRender: 'overdueStatus' }
        // },
        {
          title: this.$t(I18N_KEY + 'applicationTime'),
          align: 'left',
          dataIndex: 'createdTime'
        }
        ,
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    innerColumns () {
       return [
         {
           title: 'Period',
           align: 'left',
           dataIndex: 'period',
         },
         {
           title: 'Start Date',
           align: 'left',
           dataIndex: 'beginDate',
         },
         {
           title: 'End Date',
           align: 'left',
           dataIndex: 'endDate'
         },
         {
           title: 'Principal',
           align: 'left',
           dataIndex: 'capital'
         },
         {
           title: 'Settled Principal',
           align: 'left',
           dataIndex: 'settledCapital'
         },
         {
           title: 'Interest',
           align: 'left',
           dataIndex: 'interest'
         },
         {
           title: 'Service Fee',
           align: 'left',
           dataIndex: 'serviceFee'
         },
         {
           title: 'Late Fee',
           align: 'left',
           dataIndex: 'lateFee'
         },
         {
           title: 'Other Fees',
           align: 'left',
           dataIndex: 'otherFee'
         },
         {
           title: 'Coupon Amount',
           align: 'left',
           dataIndex: 'couponAmount'
         },
         {
           title: 'Deduction Fee',
           align: 'left',
           dataIndex: 'deductionFee'
         },
         {
           title: 'Status',
           align: 'left',
           dataIndex: 'status'
         }
       ]
    }
  },
  created () {
    // this.loadData(1)
  },
  methods: {
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // if(!this.queryParam.mobileNo.trim()){
      //   alert('Phone number is required');
      //   self.loadData();
      //   return false;
      // }
      // if(!this.queryParam.mobileNo.startsWith("182") && !this.queryParam.mobileNo.startsWith("183")){
      //   alert('Phone number must start with 182/183');
      //   self.loadData();
      //   return false;
      // }
      // Load data; if arg is 1, load first page
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams() // Query parameters
      getInstallmentPlatformAllOrderList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { createdTime } = this.queryParam;
      const data = {
          ...this.queryParam,
          applyDateStart: createdTime && this.transformTime(createdTime[0]),
          applyDateEnd: createdTime && this.transformTime(createdTime[1]),
      }
      delete data.createdTime;
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary search fields
    searchReset () {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.mobileNo = ''
       that.queryParam.aadhaarName = ''
       that.queryParam.createdTime = undefined;
      that.queryParam.loanStatus = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.settleStatus = ''
      that.loadData(this.form.pageNum)
    },
    changeModal (visible) {
        this.visible = visible;
    },
    handleDetail (row) {
        this.orderId = row.id;
        this.custInfoId = row.custInfoId;
        this.changeModal(true);
    },
    handleOrderDetail (record) {
      this.$refs.modalFormF.edit(record)
      this.$refs.modalFormF.title = 'Details'
    },
    handleOrderEdit (record) {
      this.$refs.modalFormT.edit(record)
      this.$refs.modalFormT.title = 'Edit'
    },
    handleEdit (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleLoan(id){
      const self = this;
      this.$confirm({

        title: 'Initiate Disbursement',
        // content: h => {
        //   return <div>
        //     <div>
        //       Order No: id.id
        //     </div>
        //   </div>
        // },
        onOk() {
          self.loading = true;

          installmentLoanOrder({id}).then((res) => {
            console.log(res)
            if (res.code === 1000) {
              console.log('success')
              self.$message.success(res.msg)
              self.loadData()
            } else {
              console.log('failed')
              self.$message.error(res.msg)
              self.loadData();
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });

    },
    handleLoaning(id){
      const self = this;
      this.$confirm({
        title: 'Initiate Disbursement Processing',
        onOk() {
          self.loading = true;

          installmentLoanOrderLoaning({id}).then((res) => {
            console.log(res)
            if (res.code === 1000) {
              console.log('success')
              self.$message.success(res.msg)
              self.loadData()
            } else {
              console.log('failed')
              self.$message.error(res.msg)
              self.loadData();
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });

    },
    handleAB(id){
      const self = this;
      this.$confirm({

        title: 'Initiate Loan Abandonment',
        // content: h => {
        //   return <div>
        //     <div>
        //       Order No: id.id
        //     </div>
        //   </div>
        // },
        onOk() {
          self.loading = true;

          installmentLoanOrderAB({id}).then((res) => {
            console.log(res)
            if (res.code === 1000) {
              console.log('success')
              self.$message.success(res.msg)
              self.loadData()
            } else {
              console.log('failed')
              self.$message.error(res.msg)
              self.loadData();
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });

    },
    handleFailed(id){
      const self = this;
      this.$confirm({

        title: 'Initiate Disbursement Failure',
        // content: h => {
        //   return <div>
        //     <div>
        //       Order No: id.id
        //     </div>
        //   </div>
        // },
        onOk() {
          self.loading = true;

          installmentLoanOrderFailed({id}).then((res) => {
            console.log(res)
            if (res.code === 1000) {
              console.log('success')
              self.$message.success(res.msg)
              self.loadData()
            } else {
              console.log('failed')
              self.$message.error(res.msg)
              self.loadData();
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });

    },
    handleClear(id){
      clearOrderForTest({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    downLoadData (record, type) {
      const file = {
        fileUrl: '/api/web/webpublic/order/test/getJsonData?orderType=1&orderId=' + record.id + '&type=' + type ,
        fileName: 'jsonForCustExcel.txt',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    // Modal callback
    modalFormOk () {
      this.loadData()
    },
    modalFormOkT () {
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
